import React, {useEffect, useState} from 'react';

function MerchantInput({portalBranchDTO, setPortalBranchDTO, options, type, errors}) {

    const [searchInput, setSearchInput] = useState("");

    const handleMerchantSelect = (event) => {
        setPortalBranchDTO((prevState) => ({
            ...prevState,
            MerchantID: event.target.value,
        }));
    };

    const filteredMerchants = options?.filter((merchant) =>
        merchant.MerchantGeneralInfo.MerchantLegalName.toLowerCase().includes(
            searchInput.toLowerCase()
        )
    );

    return (
        <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="row component">
                <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Merchant</div>
                <div className="col-lg-12 col-md-12 col-sm-12 desc">
                    {/*<input*/}
                    {/*    type="text"*/}
                    {/*    className="searchInput"*/}
                    {/*    placeholder="Search Merchant"*/}
                    {/*    value={searchInput}*/}
                    {/*    onChange={handleSearchInputChange}*/}
                    {/*/>*/}
                    <select
                        className="ddselect"
                        name="account"
                        id="account"
                        placeholder="Select Merchant"
                        value={portalBranchDTO.MerchantID}
                        onChange={handleMerchantSelect}
                        disabled={type==="edit"}
                    >
                        <option value="">Select Merchant</option>
                        {filteredMerchants?.map((merchant) => (
                            <option
                                key={merchant.MerchantID}
                                value={merchant.MerchantID}
                                selected={merchant.id === portalBranchDTO.MerchantID}
                            >
                                {merchant.MerchantGeneralInfo.MerchantLegalName}
                            </option>
                        ))}
                    </select>
                    {errors.MerchantID && (
                        <span className="error">{errors.MerchantID}</span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default MerchantInput;